<div class="header" [className]="'header'">
  <div class="header-icon-wrapper">
    <img *ngIf="imageURL" [src]="imageURL" class="header-icon" />
    {{ title }}
  </div>
  <button class="btn header-info" (click)="openInfoModal()" *ngIf="infoMessage">
    <img alt="info Logo" class="header-info-img" [src]="INFO_WHITE" />
  </button>
</div>
